module.exports = {"list":[{"feeName":"GST (5%)","feeNameFrench":"TPS (5%)","feeNameLong":"GST (#776624124 RT0001) (5%)","feeNameLongFrench":"TPS (#776624124 RT0001) (5%)","percentage":5,"subReason":"FEDERAL_TAX"},{"feeName":"QST (9.975%)","feeNameFrench":"TVQ (9.975%)","feeNameLong":"QST (#1223614104 TQ0001) (9.975%)","feeNameLongFrench":"TVQ (#1223614104 TQ0001) (9.975%)","percentage":9.975,"subReason":"STATE_TAX"}]}


//////////////////
// WEBPACK FOOTER
// ./view/components/create-event/helper/event-profile-request/event-fee-details/data/taxes.data.cad.json
// module id = 1453
// module chunks = 0